import { checkboxStates } from "@visiblethread/react-components";

export const getCheckboxState = (isSelected, isSomeSelected) => {
  if (isSelected) {
    return checkboxStates.checked;
  }

  if (isSomeSelected) {
    return checkboxStates.indeterminate;
  }

  return checkboxStates.empty;
};
